


export const down = require("./down.png");
export const call = require("./call.png");
export const background = require("./logo_back.png");
export const Logo = require("./logo.png");
export const pass_un = require("./password_unview.png");
export const password_view = require("./password_view.png");
export const person = require("./person.png");
export const reminder = require("./reminder.png");
export const reminder_1 = require("./reminder_1.png");
export const person2 = require("./person2.png");
export const back_icon = require("./back.png");
export const counting = require("./icon_counting.png");
export const vector = require("./Vector.png");
export const side_bar = require("./dashboard_2.png");
export const admin = require("./admin.png");
export const recharge = require("./recharge.png");
export const history = require("./history.png");
export const withdraw = require("./withdraw.png");
export const announce = require("./announce.png");
export const winning = require("./winnings.png");
export const left = require("./left.png");
export const right = require("./right.png");

export const announcement = require("./announcement.png");
export const overall = require("./overall.png");
export const report = require("./report.png");
export const link = require("./links.png");
export const apptime = require("./apptime.png");
export const help = require("./help.png");
export const logout = require("./logout.png");
export const arrow = require("./arrow.png");
export const home_active = require("./home.png");
export const home_Deactive = require("./home_no.png");

export const client_active = require("./client.png");
export const client_inactive = require("./client_no.png");
export const recharge_active = require("./recharge_1.png");
export const recharge_inactive = require("./recharge_no.png");
export const withdraw_active = require("./withdraw_1.png");
export const withdraw_inactive = require("./withdraw_no.png");
export const report_active = require("./report_1.png");
export const report_inactive = require("./report_no.png");
export const edit_icon = require("./edit_icon.png");
export const delete_icon = require("./delete.png");
export const toggle_off = require("./toggle_off.png");
export const toggle_on = require("./toggle_on.png");
export const View_icon = require("./view_icon.png");
export const calender_icon = require("./calender.png");
export const gpay = require("./gpay.png");
export const paytm = require("./patym.png");
export const phonepay = require("./phonepe.png");
export const others = require("./others.png");
export const backBtnBlack = require('./backBtn.png');

export const copy = require("./copy.png");
export const okiee = require("./thumup.png");
export const thumdown = require("./thumpdown.png");
export const facebook = require("./fb.png");
export const instragram = require("./instragram.png");
export const telegram = require("./telegram.png");
export const watup2 = require("./watup2.png");
export const cash = require("./cash.png");
export const success = require("./success.png");
export const Person_icon = require("./person_icon.png");
export const QR = require("./QR.png");

export const eyeOpen = require('./eyeOpen.png');
export const eyeClose = require('./eyeClose.png');
export const countryArr = require('./countyArr.png');
export const bg = require("./bg.png");

export const deletedata = require("./deletedata.png");
export const blockuser = require("./blockuser.png");
export const publicactivity = require("./publicactivity.png");
export const withdrawIcon = require("./withdrawIcon.png");



















































